import React, { Component, Fragment } from 'react';
import { Form, Row, Col, Select, Button } from 'antd';
import { Indicators } from './indicators';
const Option = Select.Option;

export class IndicatorForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            form: props.indicator
        };
    }

    onChange(key, value) {
        let form = { ...this.state.form };
        form[key] = value;
        this.setState({ form });
        this.props.onChange(form);
    }

    render() {
        const { indicator } = this.props;
        const { form } = this.state;
        const schema = Indicators[indicator.indicator_id];
        return (
            <Fragment>
                <Row gutter={24}>
                    <Col xs={12} md={4}>
                        <Form.Item label="Chart Period">
                            <Select
                                value={form.period || '30m'}
                                style={{ width: '100%' }}
                                disabled={schema.disablePeriod}
                                onChange={this.onChange.bind(this, 'period')}
                            >
                                <Option value={'1m'}>1m</Option>
                                <Option value={'3m'}>3m</Option>
                                <Option value={'5m'}>5m</Option>
                                <Option value={'15m'}>15m</Option>
                                <Option value={'30m'}>30m</Option>
                                <Option value={'1h'}>1h</Option>
                                <Option value={'2h'}>2h</Option>
                                <Option value={'4h'}>4h</Option>
                                <Option value={'12h'}>12h</Option>
                                <Option value={'1d'}>1d</Option>
                                <Option value={'3d'}>3d</Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    {schema.inputs.map((fieldDef, i) => {
                        let options = [...(fieldDef.options || [])];
                        if (options && fieldDef.name === 'source') {
                            let sourceIndicators = this.props.indicators;
                            //.filter((ind) => {
                            //                             if (indicator.id === ind.id) return false;
                            //                             return Indicators[ind.indicator_id].isSource;
                            //                         })
                            sourceIndicators.forEach(ind => {
                                Indicators[ind.indicator_id].outputs.forEach(output => {
                                    options.push(
                                        <Option
                                            key={`${ind.id}:${output.name}`}
                                            value={`${ind.id}:${output.name}`}
                                        >
                                            #{ind.id} {ind.indicator_id} {ind.period} -{' '}
                                            {output.label}
                                        </Option>
                                    );
                                });
                            });
                        }

                        return (
                            <Col xs={12} md={4} key={i}>
                                <Form.Item label={fieldDef.label}>
                                    <fieldDef.component
                                        onChange={this.onChange.bind(this, fieldDef.name)}
                                        value={form[fieldDef.name] || fieldDef.default}
                                        placeholder={`default: ${fieldDef.default}`}
                                        style={{ width: '100%' }}
                                    >
                                        {options ? options : null}
                                    </fieldDef.component>
                                </Form.Item>
                            </Col>
                        );
                    })}
                </Row>
                <div style={{ textAlign: 'right', padding: 10 }}>
                    <Button type="danger" onClick={this.props.onRemove.bind(this)}>
                        Remove Indicator
                    </Button>
                </div>
            </Fragment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Account/Strategies/Shared/IndicatorManager/IndicatorForm.js